module.exports = __webpack_public_path__ + "img/Webで学ぶ JavaScript 2020_2_4_1.5207e1f4.jpeg";